import { css } from "@emotion/react";
import { bpoints } from "../../../Utils";

export function generateBudgetPDFCSS() {

    return css`
        display: flex;
        flex-direction: column;
        height: 100vh;
        justify-content: space-between;

        section {
            height: 61vh;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-align: center;

            p {
                margin: 0.7rem;
                font-size: 1.8rem;
            }
            
            .image {
                animation: pulse 1.5s infinite;
                img{
                width: 200px;
            }

            }
        }

        @keyframes pulse {
            0% {
                transform: scale(0.7);
            }

            70% {
                transform: scale(1);
            }

            100% {
                transform: scale(0.7);
            }
        }
    `;
}